(function (root, factory) {
  const api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else root.SilkCraneReturn = api;
})(typeof window === 'undefined' ? globalThis : window, function () {
  'use strict';
  const VERSION = '1.0.0';
  const TTL = 24 * 60 * 60 * 1000;
  const COPY = ['form_key', 'heading_luggage', 'heading_sports', 'intro', 'choice_heading', 'provided_label', 'undecided_label', 'details_label', 'details_help', 'undecided_help', 'error_text'];
  const ALL_PROPERTIES = ['_sc_return_format_version', '_sc_return_controller_version', '_sc_return_form_key', '_sc_return_content_revision', '_sc_return_status', 'Return plans', 'Return delivery details'];
  function check(ok, code = 'RETURN_CONFIG_INVALID') { if (!ok) { const error = new Error(code); error.code = code; throw error; } }
  function validateForm(form) {
    check(form && typeof form === 'object' && Object.keys(form).length === COPY.length + 3);
    check(form.format_version === 1 && Number.isSafeInteger(form.content_revision) && form.content_revision > 0);
    check(Number.isInteger(form.max_length) && form.max_length > 0 && form.max_length <= 1000);
    COPY.forEach((key) => check(typeof form[key] === 'string' && form[key].trim().length > 0 && form[key].length <= 1000));
    check(/^[a-z][a-z0-9_]{0,119}$/.test(form.form_key));
    return form;
  }
  function validateAnswers(form, answers, partial = false) {
    validateForm(form);
    check(answers && Object.keys(answers).length === 2 && typeof answers.details === 'string', 'RETURN_ANSWER_INVALID');
    check(['provided', 'undecided', ...(partial ? [''] : [])].includes(answers.status), 'RETURN_CHOICE_REQUIRED');
    const details = answers.details.replace(/\r\n?/g, '\n').trim();
    check(answers.details.length <= form.max_length, 'RETURN_TEXT_TOO_LONG');
    check(answers.status === 'provided' || details === '', 'RETURN_INACTIVE_DETAILS');
    if (!partial && answers.status === 'provided') check(details.length > 0, 'RETURN_DETAILS_REQUIRED');
    return { status: answers.status, details };
  }
  function properties(form, answers) {
    const a = validateAnswers(form, answers);
    const p = { _sc_return_format_version: '1', _sc_return_controller_version: VERSION, _sc_return_form_key: form.form_key, _sc_return_content_revision: String(form.content_revision), _sc_return_status: a.status, 'Return plans': form[a.status + '_label'] };
    if (a.status === 'provided') p['Return delivery details'] = a.details;
    return p;
  }
  function bindingFor(form, itemId, sourcePage) { return { item_id: itemId, source_page_key: sourcePage, form_key: form.form_key, format_version: 1, content_revision: form.content_revision }; }
  function decodeDraft(raw, binding, form, now = Date.now()) {
    try {
      if (!raw || raw.length > 12000) return null;
      const d = JSON.parse(raw);
      check(d && Object.keys(d).length === 3 && d.binding && Object.keys(d.binding).length === Object.keys(binding).length);
      check(Object.keys(binding).every((key) => d.binding[key] === binding[key]));
      check(Number.isFinite(d.updated_at) && d.updated_at <= now && now - d.updated_at < TTL);
      validateAnswers(form, d.answers, true);
      return d;
    } catch { return null; }
  }
  function normalize(propertiesMap) {
    if (!ALL_PROPERTIES.some((key) => Object.hasOwn(propertiesMap, key))) return { return_capture_status: 'not_captured', return_status: null, return_details: null };
    const status = propertiesMap._sc_return_status;
    check(propertiesMap._sc_return_format_version === '1' && propertiesMap._sc_return_controller_version === VERSION, 'RETURN_EXPORT_VERSION');
    check(['provided', 'undecided'].includes(status) && typeof propertiesMap['Return plans'] === 'string', 'RETURN_EXPORT_INVALID');
    check(typeof propertiesMap._sc_return_form_key === 'string' && /^[a-z][a-z0-9_]{0,119}$/.test(propertiesMap._sc_return_form_key), 'RETURN_EXPORT_INVALID');
    check(/^[1-9]\d*$/.test(propertiesMap._sc_return_content_revision), 'RETURN_EXPORT_INVALID');
    const rawDetails = propertiesMap['Return delivery details'];
    const details = typeof rawDetails === 'string' ? rawDetails.replace(/\r\n?/g, '\n').trim() : rawDetails;
    check(status === 'provided' ? typeof details === 'string' && details.trim().length > 0 && details.length <= 1000 : details === undefined, 'RETURN_EXPORT_INVALID');
    return { return_capture_status: 'captured', return_status: status, return_details: details || null, return_form_key: propertiesMap._sc_return_form_key, return_content_revision: Number(propertiesMap._sc_return_content_revision) };
  }
  class View {
    constructor({ root, form, browser, binding, onChange, onStorageError }) {
      this.root = root; this.form = validateForm(form); this.browser = browser; this.binding = binding;
      this.onChange = onChange; this.onStorageError = onStorageError;
      this.heading = root.querySelector('[data-sc-return-heading]');
      this.disclosure = root.querySelector('details');
      this.radios = Array.from(root.querySelectorAll('[data-sc-return-choice]'));
      this.input = root.querySelector('[data-sc-return-input]');
      this.details = root.querySelector('[data-sc-return-details]');
      this.undecided = root.querySelector('[data-sc-return-undecided]');
      this.error = root.querySelector('[data-sc-return-error]');
      this.answers = { status: '', details: '' }; this.updatedAt = null; this.locked = false; this.failed = false;
      this.key = `sc_return_draft_v1:${binding.item_id}`;
      const raw = browser.sessionStorage.getItem(this.key);
      if (raw !== null) {
        browser.sessionStorage.removeItem(this.key);
        check(browser.sessionStorage.getItem(this.key) === null, 'IDENTITY_STORAGE_UNAVAILABLE');
      }
      root.addEventListener('click', (event) => {
        if (this.disclosure.open || this.locked || this.failed || event.defaultPrevented) return;
        if (event.target.closest('summary, a, button, input, select, textarea, label')) return;
        this.disclosure.open = true; this.disclosure.querySelector('summary').focus();
      });
      this.radios.forEach((radio) => radio.addEventListener('change', () => {
        if (this.locked || this.failed) return;
        this.expire();
        this.answers = { status: radio.value, details: radio.value === 'provided' ? this.answers.details : '' };
        this.edited();
        if (radio.value === 'provided') this.input.focus();
      }));
      this.input.addEventListener('input', () => {
        if (this.locked || this.failed || this.input.disabled) return;
        const value = this.input.value;
        this.expire();
        if (this.answers.status !== 'provided') { this.render(); this.onChange(); return; }
        this.answers.details = value; this.edited();
      });
      this.render();
    }
    edited() {
      this.updatedAt = Date.now(); this.error.hidden = true;
      try {
        const raw = JSON.stringify({ binding: this.binding, updated_at: this.updatedAt, answers: this.answers });
        this.browser.sessionStorage.setItem(this.key, raw);
        check(this.browser.sessionStorage.getItem(this.key) === raw, 'IDENTITY_STORAGE_UNAVAILABLE');
      } catch { this.failed = true; this.locked = true; this.onStorageError(); }
      this.render(); this.onChange();
    }
    expire() { if (this.updatedAt !== null && Date.now() - this.updatedAt >= TTL) { this.clear(); return true; } return false; }
    clear() {
      this.answers = { status: '', details: '' }; this.updatedAt = null; this.disclosure.open = false;
      try { this.browser.sessionStorage.removeItem(this.key); check(this.browser.sessionStorage.getItem(this.key) === null); }
      catch { this.failed = true; this.onStorageError(); }
      this.render(); return !this.failed;
    }
    setPackage(key, storageType) {
      this.expire(); this.heading.textContent = this.form[storageType === 'sports_gear' ? 'heading_sports' : 'heading_luggage'];
      this.root.hidden = false; this.render();
    }
    setLocked(locked) { this.locked = locked || this.failed; this.render(); }
    valid() { if (this.failed) return false; try { validateAnswers(this.form, this.answers); return true; } catch { return false; } }
    snapshot() {
      this.expire(); check(!this.failed, 'IDENTITY_STORAGE_UNAVAILABLE');
      try { return properties(this.form, this.answers); }
      catch (error) { this.disclosure.open = true; this.error.hidden = false; this.error.focus(); throw error; }
    }
    render() {
      const provided = this.answers.status === 'provided';
      this.radios.forEach((radio) => { radio.checked = radio.value === this.answers.status; radio.disabled = this.locked || this.failed; });
      this.details.hidden = !provided; this.input.disabled = !provided || this.locked || this.failed; this.input.required = provided;
      this.input.value = provided ? this.answers.details : '';
      this.undecided.hidden = this.answers.status !== 'undecided';
    }
  }
  return { VERSION, TTL, COPY, ALL_PROPERTIES, validateForm, validateAnswers, properties, bindingFor, decodeDraft, normalize, View };
});
